export default __webpack_public_path__ + "static/media/OsdeForm.fd27cbe3.png";